import { Row, Col, Label } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import AsyncSelect from 'react-select/async'
import React, { useState, useEffect } from 'react'
import _debounce from 'lodash.debounce'

import { apiAutocomplete } from '../../api'

const autocompletePlaces = _debounce((text, callback) => {
  const lang = 'es'

  if (text.length < 3) {
    callback([])
  } else {
    apiAutocomplete
      .places({ lang, text })
      .then(({ data, status }) => {
        let options = []
        if (status === 200) {
          options = data.result.map((place) => ({
            value: place.geonameid,
            data: { ...place },
            label: `${place.name} (${place.countryName})`,
          }))
        }

        callback(options)
      })
      .catch((err) => {
        console.error(err)

        callback([])
      })
  }
}, 250)

// eslint-disable-next-line react/display-name
export default (props) => {
  const { onChange, titleChild, defaultInputValue = '', className = '', name = 'place', titleText = 'dashboard_destination' } = props

  // const [inputValue, setInputValue] = useState({})

  const [defaultOptions, setDefaultValues] = useState([])

  useEffect(() => {
    autocompletePlaces(defaultInputValue, setDefaultValues)
  }, [defaultInputValue])

  const renderTitle = titleChild ? titleChild : <Label className='font-weight-bold'>{I18n.t(titleText)}</Label>

  const onSelected = (value, e) => {
    switch (e.action) {
      case 'select-option':
        onChange(name, value)
        break
      case 'clear':
        onChange(name, {})
        break
      default:
        break
    }
  }

  return (
    <Row className={`mt-3 ${className}`}>
      <Col>
        {renderTitle}

        <AsyncSelect
          name={name}
          defaultInputValue={defaultInputValue}
          defaultOptions={defaultOptions}
          placeholder={I18n.t('dashboard_search-your-destiny')}
          noOptionsMessage={(e) => (e.inputValue ? I18n.t('dashboard_no_results_found') : null)}
          loadingMessage={() => I18n.t('dashboard_searching')}
          loadOptions={autocompletePlaces}
          onChange={onSelected}
          isClearable
          isLoading
        />
      </Col>
    </Row>
  )
}
